<template>
	<div class="border-bottom mb-3 pb-3">  
    <div class="row no-gutters">
      <div class="col-9">
        <p class="mb-0 body-2-2 font-bold text-truncate">{{data.name}}</p>
        <p class="mb-1 body-2-2-1 text-truncate">{{data.description}}</p>
        <div class="w-100">
          <p v-if="is_decrease_promo" class="mb-0 ls-0-1 text-14 text-light-menu text-line-through d-inline-block align-middle">{{formatCurrency(promotion_price)}}</p>
          <p class="mb-0 body-2-2 text-truncate d-inline-block align-middle"><span class="text-orange mr-2 font-bold">{{formatCurrency(final_price)}}</span> <template v-if="is_variant">| <span class="ml-2 font-semibold">{{data.variant_list.length > 1 ? `${data.variant_list.length} Variants` : `${data.variant_list.length} Variant`}}</span></template></p>
        </div>
      </div>
      <div class="col-3 text-right align-self-center">
        <p v-if="qtyCart > 0 && is_variant" class="text-center w-100 mb-0 body-3-3 text-orange font-bold">({{qtyCart}}x)</p>
        <button v-if="qtyCart == 0 || is_variant" type="button" class="button-secondary text-12 align-top py-1 px-3" @click="changeQtyProduct('plus')">{{qtyCart == 0 ? $t('hotel.action.add') : $t('hotel.action.add-more')}}</button>
        <div v-if="qtyCart > 0 && !is_variant" class="row rounded-4 py-1 box-shadow-cart text-right w-100 no-gutters">
          <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('minus')">
            <img src="../../../../assets/img/icon/minus-orange.png" width="14">
          </div>
          <div class="col-4 text-center">
            <p class="mb-0 body-2-4 position-relative" style="top: 3px;">{{qtyCart}}</p>
          </div>
          <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('plus')">
            <img src="../../../../assets/img/icon/plus-orange.png" width="14">
          </div>
        </div>
      </div>
    </div>
    <popupWarningAddProduct v-if="show_popup" @close="show_popup = false"></popupWarningAddProduct>
  </div>
</template>
<script>
	import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'
  import {mapGetters,mapMutations} from 'vuex';

	export default{
		props: ['data'],
    data(){
      return{
        show_popup: false
      }
    },
		computed:{
			is_variant(){
        return this.data.variant_list.length == 0 ? false : true
      },
      base_price(){
        return this.is_variant ? this.data.variant_list[0].price : this.data.price
      },
      final_price(){
        return calculateFinalPriceConcierge(this.base_price)
      },
      promotion_price(){
        if(this.base_price.promotion_amount == 0){
          return 0
        }else{
          return this.base_price.tax_service_calculation_type == 'INCLUDE' ? (this.base_price.price_sell_base) : this.base_price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.base_price.promotion_amount == 0){
          return false
        }else{
          return this.base_price.promotion_type == 'INCREASE' ? false : true
        }
      },
      qtyCart(){
        let data = 0

        let record = this.getConciergeOrder().cart.findIndex(x=>x.product.data.product_id == this.data.product_id)
        if(record != -1){
          data = this.getConciergeOrder().cart[record].qty
        }

        return data
      }
		},
		methods:{
			...mapGetters(['getMerchant','getConciergeOrder','getConciergeReservation']),
      ...mapMutations(['setConciergeOrder','removeConciergeOrder']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      openDetail(){
      	this.$emit('detail', this.data)
      },
      changeQtyProduct(type){
        if(this.getConciergeReservation().status == 'CHECKIN'){
        	if(type == 'plus' && this.is_variant){
            this.openDetail()
          }else{
            let params = {
              product: this.data,
              variant: {},
              qty: this.qtyCart
            }
            if(this.qtyCart == 1 && type == 'minus'){
              this.removeConciergeOrder(params)
            }else{
              if(type == 'minus'){
                params.qty--
              }else{
                params.qty++
              }
              this.setConciergeOrder(params)
            }
          }
        }else{
          this.show_popup = true
        }
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/menuNoImage.vue